'use client'

import { useCart } from "@/contexts/cart"
import { useLocale } from "@/contexts/locale-provider"
import { ShoppingBag } from 'lucide-react'
import Image from 'next/image'
import Link from 'next/link'
import logo from '../../../public/uploads/logo.png'
import LocaleSelector from './locale-selector'

export function Header() {
  const { cart } = useCart()
  const { localeOptions, currentLocale } = useLocale()
  const cartItemCount = cart?.items?.reduce((total, item) => total + item.quantity, 0) || 0

  return (
    <header className='border-b'>
      <div className='mx-auto max-w-screen-xl px-6'>
        <div className='flex h-16 items-center justify-between'>
          <div className='flex items-center space-x-8'>
            <Image
              src={logo}
              alt="minimist"
              height={40}
              className="h-10"
              priority
            />
          </div>

          <div className='flex items-center space-x-6'>
            <Link
              href='/cart'
              className='relative text-gray-600 hover:text-black'
            >
              <ShoppingBag className='h-5 w-5' />
              {cartItemCount > 0 && (
                <span className='absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-primary text-xs text-primary-foreground'>
                  {cartItemCount}
                </span>
              )}
            </Link>
            <LocaleSelector currentLocale={currentLocale} localeOptions={localeOptions} />
          </div>
        </div>
      </div>
    </header>
  )
}
